import classNames from 'classnames';
import camelCase from 'lodash-es/camelCase';

import { useAuthorUrlGenerator } from '../../hooks/useUrlGenerator';
import getRatio from '../../lib/getRatio';
import normalizeCardTheme from '../../lib/normalizeCardTheme';

import AuthorImage from '../partials/AuthorImage';
import CardSubtitle from '../typography/CardSubtitle';
import CardTitle from '../typography/CardTitle';
import HorizontalCard from './HorizontalCard';

import styles from '../../styles/cards/author-horizontal-card.module.css';

interface AuthorHorizontalCardProps extends Partial<Author> {
    linkQuery?: Record<string, unknown> | null;
    size?: CardSize | null;
    ratio?: CardRatio | null;
    theme?: CardTheme | LegacyCardTheme | null;
    height?: string | number | null;
    placeholder?: boolean;
    className?: string | null;
}
function AuthorHorizontalCard({
    slug = null,
    linkQuery = null,
    name = null,
    role = null,
    image = null,
    ratio = null,
    theme: providedTheme = null,
    size = null,
    height: providedHeight,
    placeholder = false,
    className = null,
}: AuthorHorizontalCardProps) {
    const theme = normalizeCardTheme(providedTheme);
    const url = useAuthorUrlGenerator();
    let defaultHeight = 70;
    if (theme === 'menu') {
        defaultHeight = 50;
    } else if (size === 'big') {
        defaultHeight = 115;
    }
    const height = providedHeight || defaultHeight;
    const thumbnailRatio = getRatio(ratio, 1);
    return (
        <HorizontalCard
            presentation="author-horizontal"
            theme={theme || 'none'}
            size={size || 'default'}
            href={
                url(
                    {
                        slug,
                    },
                    linkQuery,
                ) || '#'
            }
            thumbnail={
                <AuthorImage
                    name={name}
                    slug={slug}
                    media={image}
                    className={styles.thumbnail}
                    initialsClassName={styles.initials}
                    width={height * thumbnailRatio}
                    height={height}
                    size="small"
                    withPlaceholder={placeholder}
                />
            }
            thumbnailRatio={thumbnailRatio}
            height={height}
            className={classNames([
                styles.container,
                styles[camelCase(ratio)],
                {
                    [className]: className !== null,
                },
            ])}
            labelClassName={styles.label}
        >
            <CardTitle
                tag="strong"
                className={styles.title}
                placeholder={placeholder}
                placeholderLines={1}
            >
                {name}
            </CardTitle>
            {role !== null ? (
                <CardSubtitle tag="span" className={styles.role}>
                    {role}
                </CardSubtitle>
            ) : null}
        </HorizontalCard>
    );
}
export default AuthorHorizontalCard;
